var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect2, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon, _polygon2, _polygon3, _rect3, _text, _rect4, _path52, _path53, _path54, _line, _line2, _line3, _line4, _path55, _g, _path56, _path57, _path58, _path59, _path60, _g2, _g3, _path61, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _path62, _path63, _path64, _line11, _line12, _line13, _line14, _circle, _path65, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutusntab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-17,.cls-22,.cls-25,.cls-28,.cls-29,.cls-30,.cls-31{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{fill:#82d4f6;}.cls-4{fill:#cbe6ef;}.cls-5{fill:#fdc437;}.cls-6{fill:#f2d686;}.cls-7{fill:#fec536;}.cls-8{fill:#f8a582;}.cls-21,.cls-9{fill:#2e1f42;}.cls-10{fill:#dfd4e9;}.cls-11{fill:#9a499c;}.cls-12,.cls-17{stroke:#213242;}.cls-12,.cls-17,.cls-22,.cls-25,.cls-28,.cls-29,.cls-30,.cls-31{stroke-miterlimit:10;}.cls-12{stroke-width:0.9px;}.cls-13{fill:#f47755;}.cls-14{fill:#e95343;}.cls-15{fill:#fff;}.cls-16{fill:#51687c;}.cls-17{stroke-width:0.39px;}.cls-18{fill:#9ea5ad;}.cls-19{fill:#a0813a;}.cls-20{fill:#3b5972;}.cls-21{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-22,.cls-28,.cls-29,.cls-30,.cls-31{stroke:#2e1f42;}.cls-22{stroke-width:1.09px;}.cls-23{opacity:0.5;}.cls-24{clip-path:url(#clip-path);}.cls-25{stroke:#4f4e4f;stroke-width:0.84px;}.cls-26{clip-path:url(#clip-path-2);}.cls-27{clip-path:url(#clip-path-3);}.cls-28{stroke-width:1.19px;}.cls-29{stroke-width:0.72px;}.cls-30{stroke-width:4.2px;}.cls-31{stroke-width:0.72px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 540.98,
    y: 201.56,
    width: 35.08,
    height: 39.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 546.4,
    y: 204.59,
    width: 8.55,
    height: 8.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 544.69,
    y: 203.44,
    width: 11.98,
    height: 11.26
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "about us n tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.82,55.75l-5.89.56a15.46,15.46,0,0,0-30,.38c-5-1.06-9.77.5-12.06,3.91a10.45,10.45,0,0,0-1.42,5.28A10.16,10.16,0,0,0,51.6,76H90.82a10.13,10.13,0,1,0,0-20.26",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.5,53.68l-4.83.46a12.65,12.65,0,0,0-24.54.31c-4.11-.87-8,.41-9.87,3.2A8.49,8.49,0,0,0,66.09,62a8.32,8.32,0,0,0,8.3,8.29H106.5a8.29,8.29,0,1,0,0-16.58",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.13,214.37h0a9.37,9.37,0,0,0-.1-2.9h0l1.31-1.79-.91-2-2.21-.21v0a9.09,9.09,0,0,0-2.12-2h0l-.35-2.2-2.06-.78L29,204v0a9.31,9.31,0,0,0-2.89.1h0l-1.8-1.3-2,.9-.2,2.22h0a9.43,9.43,0,0,0-2,2.11h0l-2.19.34-.78,2.06,1.42,1.71h0a9,9,0,0,0,.1,2.89h0l-1.31,1.8.91,2,2.21.2h0a9.54,9.54,0,0,0,2.12,2h0l.35,2.2L25,224l1.71-1.42h0a9.32,9.32,0,0,0,2.89-.1h0l1.8,1.3,2-.9.21-2.22h0a9.25,9.25,0,0,0,2-2.11h0l2.19-.35.78-2Zm-2.26,1.54a7.52,7.52,0,1,1-4.37-9.69,7.52,7.52,0,0,1,4.37,9.69",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126,201.54c1.39,7.31-4.64,12.49-11.48,9.67a14.45,14.45,0,0,1-6.57-5.88c-7.73-12-3.81-22.33,7-21.27,6.64.65,9.71,10.24,11.1,17.48",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.36,124.4c-7.29,1.52-12.57-4.42-9.87-11.31a14.5,14.5,0,0,1,5.77-6.67c11.89-7.93,22.27-4.19,21.39,6.58-.54,6.65-10.07,9.9-17.29,11.4",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M199.69,170c1.29,11.78,9,38.11,14.31,43.26,6.94,6.72,29.76,20.85,41.65,28.1,2.15,1.31-7.93,10-7.93,10s-31.56-13.5-43.62-24.14c-3.41-3-10.33-12.51-18.15-30.59-2.37-5.49-8.11-16.55-7.81-23.76.34-8.3,13.52-6.93,21.55-2.88",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.32,237.64s8.59,3.26,11.63,6.84,7.06,6.63,6.08,8.05-5.43-2.72-5.43-2.72-1.22,4.54-5.54,5-12.5-8-12.5-8Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.58,202.85c0,.75,0,1.63,0,2.63s0,2.1.07,3.32c0,.83.05,1.71.08,2.63s.06,1.59.09,2.43.08,1.73.12,2.64c.6,12.34,2,29.38,5.22,43H212c-2.22-9.93-5.63-25.59-8.34-45.91q-.17-1.27-.33-2.58l-.33-2.64c-.06-.47-.12-.95-.17-1.43s-.09-.78-.14-1.17c-.12-1.09-.24-2.17-.33-3.23-.09-.88-.17-1.75-.24-2.6-1.15-13.66-.74-23.9-2.39-30-1.92-7.14-24.27-15.32-24.27-15.32l-14,.73s-13.35,4.36-20.49,10.63-1.17,25-1.34,35.59c0,.36,0,.79,0,1.27",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M139.59,205.48a157.68,157.68,0,0,0,18.63,1,276.37,276.37,0,0,0,44.1-3.93c-.09-.88-.17-1.75-.24-2.6-5.38,1-36.5,6.09-62.5,2.87,0,.74,0,1.63,0,2.63",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M139.66,208.8c0,.83.05,1.71.08,2.63a155.15,155.15,0,0,0,18.48,1,276.86,276.86,0,0,0,44.74-4c-.06-.47-.12-.95-.17-1.43s-.09-.78-.14-1.17c-3.09.57-35.81,6.34-63,3",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M139.83,213.86q.06,1.27.12,2.64a153.92,153.92,0,0,0,19.28,1.11,276,276,0,0,0,44.39-4q-.17-1.27-.33-2.58c-4.82.85-37,6.27-63.46,2.81",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M171.38,168.06c-7,0-13.38-7.4-13.66-7.72a.5.5,0,0,1,.05-.7.49.49,0,0,1,.69.06c.07.07,6.8,7.83,13.52,7.36a.49.49,0,1,1,.07,1l-.67,0",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.38,168.06c-7,0-13.38-7.4-13.66-7.72a.5.5,0,0,1,.05-.7.49.49,0,0,1,.69.06c.07.07,6.8,7.83,13.52,7.36a.49.49,0,1,1,.07,1Z",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M165.35,251.29a.49.49,0,0,1-.06-1c18-2.07,25.44-33.21,25.51-33.52a.49.49,0,1,1,1,.22c-.31,1.31-7.69,32.12-26.36,34.27h-.05",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M165.35,251.29a.49.49,0,0,1-.06-1c18-2.07,25.44-33.21,25.51-33.52a.49.49,0,1,1,1,.22c-.31,1.31-7.69,32.12-26.36,34.27Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172.51,241.87a.48.48,0,0,1-.42-.23.5.5,0,0,1,.16-.68c9.57-5.89,11-14.59,11-14.67a.5.5,0,0,1,.56-.42.49.49,0,0,1,.41.56c-.05.38-1.48,9.22-11.45,15.37a.48.48,0,0,1-.26.07",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M172.51,241.87a.48.48,0,0,1-.42-.23.5.5,0,0,1,.16-.68c9.57-5.89,11-14.59,11-14.67a.5.5,0,0,1,.56-.42.49.49,0,0,1,.41.56c-.05.38-1.48,9.22-11.45,15.37A.48.48,0,0,1,172.51,241.87Z",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M186.63,122.26a19.71,19.71,0,1,1-19.71-19.7,19.7,19.7,0,0,1,19.71,19.7",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.86,125s4.39.71,3.65-4.71c-.62-4.61,3.83-2.24,3.59-6.46-.48-8.15-4.81-5.69-9-8-1.78-1-2.64-5.8-11.11-8.19-12.68-3.58-17.64,11-23.29,11.37-8.32.5-4.3,5.41-5.12,9.18s3.2,7.51,3.2,7.51Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M183.32,127.78s3.12-4.16,5.44-.72-1,13.6-6.64,11.12Z",
    transform: "translate(0 0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M183.36,135a.48.48,0,0,0,.46-.35,7.4,7.4,0,0,1,4.16-4.42.48.48,0,1,0-.34-.9,8.31,8.31,0,0,0-4.75,5.06.48.48,0,0,0,.34.59l.13,0",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M186.64,133.46a.42.42,0,0,0,.26-.08.47.47,0,0,0,.14-.66,4.35,4.35,0,0,0-1.8-1.45.48.48,0,0,0-.39.87,3.38,3.38,0,0,1,1.38,1.1.5.5,0,0,0,.41.22",
    transform: "translate(0 0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.68,146.8v10.11s4.16,4.45,8.23,4.8,6.55-4.48,6.55-4.48v-9.72Z",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.68,146.8v4.49c2.74,3,7.59,3.79,14.78,2.73v-6.51Z",
    transform: "translate(0 0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M150,120.84a98.73,98.73,0,0,0,1.32,12.77c.18,1,.39,1.9.63,2.73,2.13,7.45,7.45,20.22,22.34,14.9,6.58-2.35,9.63-9.68,11-17.13a71.92,71.92,0,0,0,1-13.83,10.56,10.56,0,0,0-5.35-9c-8.79-5-18.07-3.12-24.18-.77A10.52,10.52,0,0,0,150,120.84",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.83,129.1c0,1.08.56,2,1.24,2s1.24-.87,1.24-2-.55-2-1.24-2-1.24.88-1.24,2",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M161.29,129.1c0,1.08.55,2,1.24,2s1.24-.87,1.24-2-.56-2-1.24-2-1.24.88-1.24,2",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.11,123.1s-4.46-1.77-8.29-.64a1,1,0,0,0-.71,1.17h0a1,1,0,0,0,1.14.84,17,17,0,0,1,6.65.46,1,1,0,0,0,1.28-.69,1.7,1.7,0,0,0-.07-1.14",
    transform: "translate(0 0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.45,123.1s4.47-1.77,8.29-.64a1,1,0,0,1,.71,1.17h0a1,1,0,0,1-1.14.84,17.06,17.06,0,0,0-6.65.46,1,1,0,0,1-1.27-.69,1.63,1.63,0,0,1,.06-1.14",
    transform: "translate(0 0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M169,137.28a5.18,5.18,0,0,1-1.74-.36.48.48,0,0,1,.36-.89,2.87,2.87,0,0,0,1.93.18c.09-.05.2-.15.23-.45a69.35,69.35,0,0,0-.29-7.35.49.49,0,0,1,.44-.52.48.48,0,0,1,.52.44,71.66,71.66,0,0,1,.29,7.53,1.48,1.48,0,0,1-.7,1.18,2.07,2.07,0,0,1-1,.24",
    transform: "translate(0 0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M175,139.72c-.39,2-1.7,5.61-6.09,5.61s-5.64-3.32-6.07-5.61Z",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M169,147.84a5,5,0,0,1-2.34-.66.48.48,0,1,1,.5-.82,4.06,4.06,0,0,0,1.84.52,3.82,3.82,0,0,0,1.75-.52.48.48,0,0,1,.5.82,4.87,4.87,0,0,1-2.25.66",
    transform: "translate(0 0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.09,131a21.2,21.2,0,0,0,.47-6.09c-.48-2.41-2.43-3.83-1.78-6.16s-1.75-4.84-3.52-5.25-5.9.48-10-1.5c-3.88-1.89-10.63-.54-11.73,2-1.33,3.09.48,3.38-3.15,6.72-1.45,1.33.27,4.79.51,7a15.49,15.49,0,0,1,.09,2.66V131h-4.35c-.48-3.49-.76-7.34-.91-10.56a11,11,0,0,1,6.85-10.74c6.21-2.44,15.64-4.38,24.58.81a11,11,0,0,1,5.44,9.35,81.42,81.42,0,0,1-.52,11.14Z",
    transform: "translate(0 0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.81,132.83a17.78,17.78,0,0,0-.27-3.34c-.26-1.51-.7-2.87-2.24-3.5a2.63,2.63,0,0,0-3.51.88c-2.32,3.44.27,14.15,6,11.67Z",
    transform: "translate(0 0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M151.64,135.42a.46.46,0,0,1-.38-.43,7.39,7.39,0,0,0-3.22-5.15.49.49,0,0,1-.15-.67.48.48,0,0,1,.66-.15,8.31,8.31,0,0,1,3.66,5.89.48.48,0,0,1-.44.52h-.13",
    transform: "translate(0 0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M148.73,133.23a.47.47,0,0,1-.24-.13.49.49,0,0,1,0-.68,4.4,4.4,0,0,1,2.05-1.07.48.48,0,0,1,.22.94,3.63,3.63,0,0,0-1.58.8.49.49,0,0,1-.44.14",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.77,163.79c7,10.64,33.88,47.41,39.94,51.69,7.88,5.56,29.39,13.46,41.73,21.71,4.2,2.8-5.71,10.73-5.71,10.73s-30.1-8.46-43.65-17.12c-3.84-2.44-19.78-18.42-30-32.59-3.48-4.85-9.15-11.59-10-18.76-.94-8.26,1.65-12.67,7.61-15.66",
    transform: "translate(0 0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M197,259.54h83.67a1.93,1.93,0,0,0,1.93-1.94v-6.66a1.93,1.93,0,0,0-1.93-1.94H197a1.93,1.93,0,0,0-1.93,1.94v6.66a1.93,1.93,0,0,0,1.93,1.94",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 195.07,
    y: 249,
    width: 87.54,
    height: 10.54,
    rx: 1.94
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M282.58,259.54,299,197.92a5.46,5.46,0,0,0-5.27-6.86h-36.2a5.45,5.45,0,0,0-5.25,4l-18.12,64.5Z",
    transform: "translate(0 0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M252.31,195l-18,64h-4.14l18-64a5.45,5.45,0,0,1,5.25-4h4.14a5.47,5.47,0,0,0-5.26,4",
    transform: "translate(0 0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M252.31,195l-18,64h-4.14l18-64a5.45,5.45,0,0,1,5.25-4h4.14A5.47,5.47,0,0,0,252.31,195Z",
    transform: "translate(0 0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.62,228.06c-.94,4.06,1.6,7.36,5.66,7.36a9.83,9.83,0,0,0,9.06-7.36c.94-4.06-1.59-7.36-5.65-7.36a9.83,9.83,0,0,0-9.07,7.36",
    transform: "translate(0 0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.21,260.11a6.4,6.4,0,0,1-5.73-1.78,5.22,5.22,0,0,1-1.59-3.42v-.06c0-8.51-10.43-7.94-13.79-18.35s9.91-11.29,17.49-4.86c5.45,4.62,12-1.83,19.91,3.56,6.88,4.67,3,16.19,14.33,12.59,3.6-1.15,6.83,0,9.55,2a16.16,16.16,0,0,1,6,9.23l-.89.63c-22.25,13.64-32.28-1.72-45.3.46",
    transform: "translate(0 0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.25,259.65l-29.5-18.93a.85.85,0,0,1,.92-1.43l31.73,20.36Z",
    transform: "translate(0 0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.91,201c.76-11.22.88-23,0-30.79-1.09-10.19-3.55-17.28-7.33-21.08a.64.64,0,1,0-.91.9c6.6,6.65,9,24.48,6.88,51.62Z",
    transform: "translate(0 0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.22,161.16s5.38,0,5-9.46c0,0-8.23,2.35-5,9.46",
    transform: "translate(0 0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.67,166s.3-5.37-9.16-5.51c0,0,1.88,8.34,9.16,5.51",
    transform: "translate(0 0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.56,152.76s2.07-5-6.8-8.25c0,0-1,8.5,6.8,8.25",
    transform: "translate(0 0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.88,175.77s5.06,1.81,7.9-7.21c0,0-8.53-.57-7.9,7.21",
    transform: "translate(0 0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.59,180.79s1.22-5.23-8.07-7c0,0,.41,8.54,8.07,7",
    transform: "translate(0 0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.88,187.71s5,1.91,8-7.06c0,0-8.52-.74-8,7.06",
    transform: "translate(0 0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.7,259.38a21,21,0,0,1,.49-4c2.76-12.64-4.75-15-14.65-19s-11.08-15.85-4.07-25.7-5.58-17.77-1-32.59,20.75-5,24.28,8.7c2.53,9.83,15.41,7.7,20.18,20.45,4.14,11.06-9.75,21.28,6.29,26.35,5.12,1.62,7.95,5.55,9.44,10.15a23,23,0,0,1-.58,15.64Z",
    transform: "translate(0 0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M123.32,259.38,96.9,194.18a1.21,1.21,0,0,1,2.24-.91l26.78,66.11Z",
    transform: "translate(0 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.45 128.88 46.55 141.53 62.22 151.31 78.45 128.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.45 128.88 54.5 146.57 54.5 152.89 51.39 145.36 78.45 128.88"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.06 147.96 54.49 152.89 54.49 146.57 58.06 147.96"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 56.93,
    y: 259.65,
    width: 242.3,
    height: 16.86,
    rx: 8.43
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(308.13 162.04)"
  }, "ABOUT US")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 374.89,
    y: 58.26,
    width: 35.14,
    height: 1.52,
    transform: "translate(47.41 255.09) rotate(-38.16)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M528.26,73.87a5.61,5.61,0,1,1-5.61-5.6,5.61,5.61,0,0,1,5.61,5.6",
    transform: "translate(0 0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M547.7,95.54a5.61,5.61,0,1,1-5.61-5.6,5.61,5.61,0,0,1,5.61,5.6",
    transform: "translate(0 0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M550.44,61.5a5.6,5.6,0,1,1-3.25-7.23,5.61,5.61,0,0,1,3.25,7.23",
    transform: "translate(0 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 527.4,
    y1: 70.91,
    x2: 540.59,
    y2: 62.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 527.4,
    y1: 70.91,
    x2: 540.59,
    y2: 62.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 524.42,
    y1: 79.18,
    x2: 538.18,
    y2: 92.37
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 524.42,
    y1: 79.18,
    x2: 538.18,
    y2: 92.37
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M295.13,53.14l-43-.67a4.15,4.15,0,0,0-4.23,4.1l-.32,20.14a4.17,4.17,0,0,0,4.1,4.23l3.52.06c.23,1.35.34,5-4.52,7.47,0,0,12.65-.41,12.94-7.34l31,.49a4.17,4.17,0,0,0,4.23-4.1l.32-20.15a4.17,4.17,0,0,0-4.1-4.23",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M576.06,219.1c0,1.61.08,6.18-2.82,9.56-1.59,1.85-3.18,2.32-4.82,5s-.91,3.66-2.17,5.15c-3,3.51-11.42,3.32-14.63-.49-1.26-1.51-.77-2.47-2.66-5-1.77-2.36-3.21-2.87-4.65-4.32-3.32-3.36-3.32-8.48-3.33-9.9,0-7.58,6.8-17.54,17.54-17.54s17.44,10,17.54,17.54",
    transform: "translate(0 0)"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M576.06,219.1c0,1.61.08,6.18-2.82,9.56-1.59,1.85-3.18,2.32-4.82,5s-.91,3.66-2.17,5.15c-3,3.51-11.42,3.32-14.63-.49-1.26-1.51-.77-2.47-2.66-5-1.77-2.36-3.21-2.87-4.65-4.32-3.32-3.36-3.32-8.48-3.33-9.9,0-7.58,6.8-17.54,17.54-17.54s17.44,10,17.54,17.54",
    transform: "translate(0 0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M565.25,241.31H552.68a2.34,2.34,0,0,1,0-4.67h12.57a2.34,2.34,0,0,1,0,4.67",
    transform: "translate(0 0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M565.68,247.61H552.92a2.24,2.24,0,0,1,0-4.48h12.76a2.24,2.24,0,0,1,0,4.48",
    transform: "translate(0 0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M565.34,254.1H553.26a2.58,2.58,0,1,1,0-5.15h12.08a2.58,2.58,0,1,1,0,5.15",
    transform: "translate(0 0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M556.42,236.64s1-9-.44-11.76-3.48,2.16-1.42,2.41a4.92,4.92,0,0,0,4.74-2.52c1.06-1.64-1.63-4.05-1.35-1.2s3.83,2.62,4.93,2.73.22-5-1-3-.22,3.06.33,4.7.22,8.59.22,8.59",
    transform: "translate(0 0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M554.48,205.25c1.08,1.23.25,3.72-1.85,5.57s-4.67,2.35-5.75,1.13-.25-3.72,1.85-5.57,4.67-2.35,5.75-1.13",
    transform: "translate(0 0)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M556,204.38c1.51,1.72.35,5.21-2.59,7.8s-6.56,3.3-8.07,1.58-.35-5.21,2.59-7.8,6.56-3.3,8.07-1.58",
    transform: "translate(0 0)"
  })))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M563,259.79h-6.49a2.78,2.78,0,0,1-2.77-2.77v-1.24a2.78,2.78,0,0,1,2.77-2.77H563a2.78,2.78,0,0,1,2.78,2.77V257a2.78,2.78,0,0,1-2.78,2.77",
    transform: "translate(0 0)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 574.27,
    y1: 201.65,
    x2: 581.07,
    y2: 196.71
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 561.45,
    y1: 198.68,
    x2: 561.45,
    y2: 190.28
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 550.12,
    y1: 199.9,
    x2: 546.25,
    y2: 192.44
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 541.72,
    y1: 206.97,
    x2: 534.44,
    y2: 202.77
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 538.37,
    y1: 216.47,
    x2: 529.96,
    y2: 216.47
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 539.21,
    y1: 226.06,
    x2: 531.77,
    y2: 229.97
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 577.78,
    y1: 212.7,
    x2: 586.18,
    y2: 213.01
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 578.96,
    y1: 224.06,
    x2: 586.59,
    y2: 227.59
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M702.76,46.82a3.71,3.71,0,1,1-5.16.93,3.71,3.71,0,0,1,5.16-.93",
    transform: "translate(0 0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M721.88,44.44a3.71,3.71,0,1,1-5.16.93,3.71,3.71,0,0,1,5.16-.93",
    transform: "translate(0 0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M704.41,30.09a3.71,3.71,0,1,1-5.15-.95,3.71,3.71,0,0,1,5.15.95",
    transform: "translate(0 0)"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 700.83,
    y1: 46.17,
    x2: 701.29,
    y2: 35.86
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 700.83,
    y1: 46.17,
    x2: 701.29,
    y2: 35.86
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 704.2,
    y1: 50.91,
    x2: 716.57,
    y2: 48.42
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 704.2,
    y1: 50.91,
    x2: 716.57,
    y2: 48.42
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 689.25,
    cy: 203.59,
    r: 15.81
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M708.38,209h10.51a0,0,0,0,1,0,0V245a4.81,4.81,0,0,1-4.81,4.81h-.89a4.81,4.81,0,0,1-4.81-4.81V209A0,0,0,0,1,708.38,209Z",
    transform: "translate(32.38 542.12) rotate(-42.48)"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 356.75,
    y1: 259.4,
    x2: 389.65,
    y2: 226.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 368.62,
    y1: 249.78,
    x2: 401.52,
    y2: 216.88
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 371.61,
    y1: 251.84,
    x2: 392.58,
    y2: 230.87
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 367.31,
    y1: 258.02,
    x2: 388.28,
    y2: 237.05
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 374.97,
    y1: 252.29,
    x2: 395.94,
    y2: 231.32
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 358.52,
    y1: 262.2,
    x2: 391.42,
    y2: 229.3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 364.29,
    y1: 249.29,
    x2: 397.19,
    y2: 216.39
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 365.31,
    y1: 245.93,
    x2: 379.55,
    y2: 231.68
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 366.48,
    y1: 241.92,
    x2: 374.55,
    y2: 233.86
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 368.4,
    y1: 237.36,
    x2: 376.46,
    y2: 229.3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 378.42,
    y1: 251.57,
    x2: 386.48,
    y2: 243.51
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 601.9,
    y1: 166.4,
    x2: 634.8,
    y2: 133.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 613.77,
    y1: 156.78,
    x2: 646.67,
    y2: 123.88
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 616.76,
    y1: 158.83,
    x2: 637.73,
    y2: 137.86
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 612.46,
    y1: 165.02,
    x2: 633.43,
    y2: 144.05
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 620.12,
    y1: 159.28,
    x2: 641.09,
    y2: 138.31
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 603.67,
    y1: 169.19,
    x2: 636.57,
    y2: 136.29
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 609.44,
    y1: 156.28,
    x2: 642.34,
    y2: 123.38
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 610.46,
    y1: 152.92,
    x2: 624.7,
    y2: 138.68
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 611.63,
    y1: 148.92,
    x2: 619.7,
    y2: 140.85
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 613.55,
    y1: 144.36,
    x2: 621.61,
    y2: 136.29
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 623.57,
    y1: 158.57,
    x2: 631.63,
    y2: 150.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusntab);
export default __webpack_public_path__ + "static/media/about us n tab.6c1152b5a250b88338bbf12d75b76489.svg";
export { ForwardRef as ReactComponent };